import { Routes, Route } from "react-router-dom";
import { useMemo } from "react";
import { AppRoutes } from "./routes";
import { PrivateRoute } from "./PrivateRoute";
import { ROUTES } from "./constants";

export function RouterManager() {
  const routes = useMemo(
    () =>
      Object.keys(AppRoutes).map((path) => {
        const RouteComponent = AppRoutes[path];
        // Tornamos privadas todas as rotas por padrão, exceto as públicas (login/cadastro/recuperação)
        const publicRoutes = [
          ROUTES.SIGNIN,
          ROUTES.SIGNUP,
          ROUTES.FORGOT_PASSWORD,
          ROUTES.RESET_PASSWORD,
          ROUTES.TERMS_OF_USE,
          ROUTES.PRIVACY_POLICY,
        ];
        const isPrivate = !publicRoutes.includes(path);

        const element = isPrivate ? (
          <PrivateRoute>
            <RouteComponent />
          </PrivateRoute>
        ) : (
          <RouteComponent />
        );

        return <Route key={path} path={path} element={element} />;
      }),
    []
  );

  return <Routes>{routes}</Routes>;
}
